import React from "react";
import { Grid } from "@material-ui/core";
import useStyles from "../common/Styles";
import ChartTogglebar from "../common/ChartTogglebar";
import AboutTogglebar from "../common/AboutTogglebar";
import ChartView from "./ChartView";
import { charts, about } from "./constants";
import { useSelector } from "react-redux";
// import { decimalRoundHelper } from "../common/utils";
import userActions from "../common/actions";
import CitiesMetrics from "./CitiesMetrics";

const CitiesView = () => {
  const classes = useStyles();
  // const [chart, setChart] = React.useState(0);
  const { chart_selected } = useSelector((state) => state.water_user);
  const { setWaterUserChart } = userActions();

  const handleChange = (e, idx) => {
    setWaterUserChart(idx);
  };

  return (
    <Grid container item className={classes.mainView}>
      <ChartTogglebar
        charts={charts}
        value={chart_selected >= charts.length ? 0 : chart_selected}
        onChange={(event, value) => handleChange(event, value)}
        // onChange={(event, value) => setChart(value)}
        setChart={setWaterUserChart}
      />
      {/* TODO: chart view title information still being fed from constants folder */}
      <ChartView chart={charts[chart_selected >= charts.length ? 0 : chart_selected]} />
      <AboutTogglebar
        // metrics={chart_selected <= 1 ? metrics[0] : metrics[1]}
        MetricsComponent={charts[chart_selected].show_stats ? <CitiesMetrics /> : undefined}
        about={about[chart_selected >= charts.length ? 0 : chart_selected]}
      />
    </Grid>
  );
};

export default CitiesView;
